<!-- Testing Toolkit Floating Panel -->
<div class="testing-toolkit" [class.expanded]="isExpanded">
    <!-- Toggle Button -->
    <button class="toolkit-toggle" [class.active]="isTestDateActive" (click)="togglePanel()" cTooltip="Testing Toolkit"
        placement="left">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path
                d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
        </svg>
        @if (isTestDateActive) {
        <span class="active-indicator"></span>
        }
    </button>

    <!-- Expanded Panel -->
    @if (isExpanded) {
    <div class="toolkit-panel">
        <div class="toolkit-header">
            <h6 class="mb-0">🛠️ Testing Toolkit</h6>
            <span class="badge bg-info-gradient">{{ currentEnvironment }}</span>
        </div>

        <div class="toolkit-body">
            <!-- Date Override Section -->
            <div class="toolkit-section">
                <label class="section-label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    Override System Date
                </label>

                <div class="date-input-group">
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="testDateInput"
                        (change)="onDateChange()" placeholder="Select date" />
                </div>

                <div class="date-actions">
                    <button class="btn btn-sm btn-outline-primary" (click)="setToToday()">
                        Today
                    </button>
                    <button class="btn btn-sm btn-outline-secondary" (click)="clearDate()"
                        [disabled]="!isTestDateActive">
                        Clear
                    </button>
                </div>

                @if (isTestDateActive) {
                <div class="status-indicator active">
                    <span class="status-dot"></span>
                    Test date is active
                </div>
                } @else {
                <div class="status-indicator">
                    <span class="status-dot inactive"></span>
                    Using system date
                </div>
                }
            </div>
        </div>

        <div class="toolkit-footer">
            <small class="text-muted">
                Changes persist across sessions
            </small>
        </div>
    </div>
    }
</div>